import { Fragment } from "react";

export const ErrorLoader = () =>
({ request, params }) => {
    location.href = 'https://www.plaync.com/error/500'; // plaync error 페이지로 가도록

    return null;
};

export const Error = () => {
    return <Fragment></Fragment>;
};